import React, { useRef, useEffect, useState, useLayoutEffect } from "react";
import {
  RootWrapper,
  HeaderStyled,
  BodyRootWrapper,
  BodyWrapper,
  BodyStyled,
} from "../../theme";
import { Logo } from "../shared/logo";
import Footer from "../shared/footer";
import styled from "styled-components";

import { Navigation } from "../shared/navigation";
import UserInfo from "../shared/userInformation";

let BOX_TITLE_HEIGHT = 53;
let HEADER_FOOTER_GAP_HEIGHT = 141;
let GAP_HEIGHT = 83;

export const useWindowSize = () => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [wrapperHeight, setWrapperHeight] = useState(0);
  const [boxHeight, setBoxHeight] = useState(0);
  const [boxHeightHalf, setBoxHeightHalf] = useState(0);
  const [popupHeight, setPopupHeight] = useState(0);
  useLayoutEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
      setWrapperHeight(window.innerHeight - HEADER_FOOTER_GAP_HEIGHT);
      setBoxHeight(
        window.innerHeight - (HEADER_FOOTER_GAP_HEIGHT + BOX_TITLE_HEIGHT)
      );
      setBoxHeightHalf(
        (window.innerHeight -
          (HEADER_FOOTER_GAP_HEIGHT + BOX_TITLE_HEIGHT + GAP_HEIGHT)) /
          2
      );
      setPopupHeight(window.innerHeight * 0.6 - BOX_TITLE_HEIGHT);
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return {
    width,
    height,
    wrapperHeight,
    boxHeight,
    boxHeightHalf,
    popupHeight,
  };
};

export const Layout = (props) => {
  const siteHeight = useRef();
  const [floatFooter, setFloatFooter] = useState(true);
  const { width, height } = useWindowSize();

  /* Update chart width and height */
  useEffect(() => {
    if (width) {
      let boxHeight = siteHeight.current.offsetHeight;
      if (height > boxHeight) {
        setFloatFooter(true);
      } else {
        setFloatFooter(false);
      }
    }
  }, [width, height]);

  return (
    <RootWrapper>
      <HeaderStyled>
        <Logo linkTo="/dashboard" />
        <UserInformation>
          <UserInfo />
        </UserInformation>
      </HeaderStyled>
      <BodyRootWrapper ref={siteHeight} floatFooter={floatFooter}>
        <BodyWrapper>
          <BodyStyled emailVerified={true}>
            <Navigation />
            <RightSideBody>{props.children}</RightSideBody>
          </BodyStyled>
          <Footer />
        </BodyWrapper>
      </BodyRootWrapper>
    </RootWrapper>
  );
};

const RightSideBody = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    flex-basis:calc(100% - 57px);
    ${
      props.isOpen &&
      `
      flex-basis:calc(100% - 242px);
    `
    };
    >div{
      padding:${current.gMD} ${current.gXL};
    };
    `;
  }}
`;

const UserInformation = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
      margin-left:auto;
      height:100%;
      display:flex;
      align-items: center;
      >span{
        height:100%;
        display:flex;
        align-items: center;
        cursor:pointer;
        padding:0 ${current.gMD};
        :hover{
          background:rgba(${current.white},0.5);
          color:rgb(${current.white})!important;
        }
      }
    `;
  }}
`;
